import { chakra } from '@chakra-ui/react';

const SVGIcon = ({ ...props }) => (
  <svg
    width="128"
    height="128"
    viewBox="0 0 128 128"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_78_3449)">
      <circle cx="64" cy="64" r="64" fill="url(#paint0_radial_78_3449)" />
      <circle cx="64" cy="64" r="64" fill="url(#paint1_radial_78_3449)" />
      <path
        d="M64 0C28.6539 0 0 28.6539 0 64C0 99.3461 28.6539 128 64 128C99.3461 128 128 99.3461 128 64C128 28.6539 99.3461 0 64 0ZM61.5247 24.4429C63.3021 23.572 65.175 23.6317 66.8988 24.6099C72.8753 28.0157 78.8339 31.4513 84.7627 34.9226C86.6714 36.044 87.6496 37.8393 87.6555 40.0462C87.6913 47.7823 87.6794 55.5124 87.6555 63.2485C87.6555 63.5348 87.4706 63.9523 87.238 64.0895C84.9417 65.4613 82.6155 66.7795 80.0924 68.2349V67.0181C80.0924 59.0613 80.0686 51.1105 80.1103 43.1538C80.1163 41.6268 79.5914 40.6427 78.2375 39.8732C71.3006 35.9307 64.3996 31.9165 57.4867 27.9262C57.1884 27.7532 56.8962 27.5683 56.4429 27.2939C58.2203 26.2859 59.8188 25.2719 61.5128 24.4429H61.5247ZM60.2542 103.587C59.8665 103.39 59.5802 103.253 59.2999 103.092C50.1443 97.8132 41.0006 92.4988 31.8151 87.2619C29.2384 85.7946 28.0634 83.701 28.0932 80.7605C28.1469 74.5096 28.129 68.2587 28.0992 62.0019C28.0872 59.1806 29.2324 57.1348 31.7137 55.7271C38.1614 52.0589 44.5733 48.337 50.9853 44.6091C51.54 44.287 51.9456 44.2334 52.5241 44.5793C54.737 45.9094 56.9916 47.1799 59.3476 48.5398C58.9003 48.8082 58.5603 49.011 58.2143 49.2138C51.2716 53.222 44.3407 57.2421 37.3801 61.2265C36.2408 61.8766 35.71 62.7236 35.7219 64.0477C35.7577 68.9745 35.7636 73.9012 35.7219 78.828C35.71 80.1879 36.2527 81.0527 37.4218 81.7208C44.7642 85.9198 52.0768 90.1666 59.4132 94.3776C60.0335 94.7355 60.296 95.1053 60.2841 95.8449C60.2304 98.3679 60.2662 100.897 60.2662 103.593L60.2542 103.587ZM60.2542 89.4747C59.616 89.1109 59.1568 88.8544 58.6975 88.586C52.876 85.228 47.0606 81.858 41.2272 78.5238C40.595 78.1659 40.3623 77.7782 40.3683 77.0445C40.4101 73.257 40.3922 69.4695 40.3802 65.682C40.3802 65.1691 40.4578 64.8171 40.9648 64.5308C43.112 63.332 45.2354 62.0794 47.3648 60.8567C47.5199 60.7672 47.6869 60.7016 47.9672 60.5644V64.8171C47.9672 67.1195 48.003 69.4278 47.9553 71.7301C47.9254 73.0423 48.4324 73.931 49.5776 74.5752C52.876 76.4362 56.1327 78.3687 59.4311 80.2237C60.0813 80.5875 60.2781 80.9931 60.2662 81.7089C60.2244 84.2259 60.2483 86.7489 60.2483 89.4688L60.2542 89.4747ZM53.5322 39.7599C52.2975 39.0322 51.2417 39.0382 50.0071 39.7599C43.0882 43.8039 36.1394 47.7942 29.1966 51.8024C28.9044 51.9754 28.6002 52.1305 28.0813 52.4108C28.2662 49.7745 27.6995 47.2872 28.6002 44.8775C29.0893 43.5594 30.0078 42.5692 31.2246 41.8654C37.0162 38.5193 42.8019 35.1672 48.6054 31.839C50.7228 30.6222 52.882 30.652 54.9994 31.8747C61.5903 35.6682 68.1752 39.4736 74.7482 43.291C75.0285 43.452 75.3804 43.8158 75.3804 44.0902C75.4281 46.7981 75.4102 49.512 75.4102 52.4168C73.0184 51.039 70.8115 49.7625 68.6047 48.4861C63.5765 45.5814 58.5364 42.7064 53.5322 39.7599ZM99.8471 82.3411C99.6742 84.4705 98.4276 85.9795 96.5845 87.0412C89.5284 91.0971 82.4783 95.1769 75.4281 99.2447C73.2153 100.521 71.0024 101.798 68.7836 103.074C68.5152 103.229 68.2408 103.36 67.877 103.551C67.8531 103.181 67.8233 102.913 67.8233 102.645C67.8233 100.306 67.8352 97.9743 67.8114 95.6362C67.8114 95.1053 67.9366 94.7832 68.4257 94.5029C78.7087 88.586 88.9856 82.6513 99.2567 76.7225C99.4117 76.633 99.5847 76.5614 99.877 76.4242C99.877 78.4999 99.9963 80.4324 99.8471 82.3411ZM99.9008 67.6205C99.8829 70.0421 98.5767 71.742 96.507 72.9349C88.4667 77.5575 80.4324 82.2039 72.3981 86.8444C70.9308 87.6913 69.4576 88.5323 67.8829 89.4389C67.8591 89.0393 67.8293 88.7769 67.8293 88.5085C67.8293 86.2061 67.8531 83.8979 67.8114 81.5955C67.7994 80.9394 68.0201 80.5935 68.5868 80.2654C75.8934 76.0723 83.1761 71.8315 90.4947 67.6623C91.795 66.9226 92.3676 66.0101 92.3556 64.4831C92.3019 56.5264 92.3318 48.5696 92.3318 40.6129V39.2231C94.2404 40.3743 96.0298 41.3226 97.6641 42.4798C99.1553 43.5355 99.9068 45.134 99.9128 46.9771C99.9366 53.8602 99.9545 60.7433 99.9068 67.6265L99.9008 67.6205Z"
        fill="#0D0D0D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64 0C28.6538 0 0 28.6538 0 64C0 99.3462 28.6538 128 64 128C99.3462 128 128 99.3462 128 64C128 28.6538 99.3462 0 64 0ZM64 5.33333C31.5993 5.33333 5.33333 31.5993 5.33333 64C5.33333 96.4007 31.5993 122.667 64 122.667C96.4007 122.667 122.667 96.4007 122.667 64C122.667 31.5993 96.4007 5.33333 64 5.33333Z"
        fill="url(#paint2_radial_78_3449)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64 0C28.6538 0 0 28.6538 0 64C0 99.3462 28.6538 128 64 128C99.3462 128 128 99.3462 128 64C128 28.6538 99.3462 0 64 0ZM64 5.33333C31.5993 5.33333 5.33333 31.5993 5.33333 64C5.33333 96.4007 31.5993 122.667 64 122.667C96.4007 122.667 122.667 96.4007 122.667 64C122.667 31.5993 96.4007 5.33333 64 5.33333Z"
        fill="url(#paint3_radial_78_3449)"
      />
    </g>
    <defs>
      <radialGradient
        id="paint0_radial_78_3449"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(33.9747 33.8201) rotate(44.9817) scale(132.974 282.008)"
      >
        <stop stopColor="#A3EEF8" />
        <stop offset="0.177083" stopColor="#A4DCF5" />
        <stop offset="0.380208" stopColor="#A6AEEC" />
        <stop offset="1" stopColor="#ECBEE1" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_78_3449"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(69.5509 120.055) rotate(84.265) scale(68.8748 131.759)"
      >
        <stop stopColor="#FCF5EE" />
        <stop offset="0.715135" stopColor="#ECBEE1" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_78_3449"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(33.9747 33.8201) rotate(44.9817) scale(132.974 282.008)"
      >
        <stop stopColor="#A3EEF8" />
        <stop offset="0.177083" stopColor="#A4DCF5" />
        <stop offset="0.380208" stopColor="#A6AEEC" />
        <stop offset="1" stopColor="#ECBEE1" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_78_3449"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(69.5509 120.055) rotate(84.265) scale(68.8748 131.759)"
      >
        <stop stopColor="#FCF5EE" />
        <stop offset="0.715135" stopColor="#ECBEE1" stopOpacity="0" />
      </radialGradient>
      <clipPath id="clip0_78_3449">
        <rect width="128" height="128" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const Immutable = chakra(SVGIcon);
export default Immutable;
